export const TikTokIcon = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="50" height="50" rx="5" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.6144 13C30.0377 16.5546 32.0194 18.6711 35.449 18.8875V22.8607C33.4528 23.0531 31.7068 22.3796 29.6769 21.1771V28.6424C29.6769 38.1375 19.3257 41.0957 15.1746 34.299C12.5002 29.9267 14.1404 22.2353 22.7168 21.9371V26.1555C22.0448 26.2647 21.3822 26.4255 20.735 26.6365C18.811 27.2763 17.7528 28.4933 18.051 30.6241C18.633 34.7079 26.1223 35.9152 25.497 27.9401V13.0144H29.6336L29.6144 13Z"
                fill="black"
            />
        </svg>
    );
};
